import { useQuery } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { Dayjs } from 'dayjs';
import { CORE_API_SUFFIX, dataFetch } from '../../axios/customAxios';
import { appendQueryParamIfNotEmpty, formatDate, generateQueryKey } from '../../constants/hookConstants';

const useGetFormSubmissions = (
  identifier: string,
  AdCode: string,
  Status: number | null,
  referrer: string,
  originalReferrer: string,
  superOfficeId: string,
  digId: string,
  orderBy: string,
  sortBy: string,
  from: Dayjs | null,
  to: Dayjs | null,
  rows: number,
  page: number,
  fields: any | null,
) => {
  const navigate = useNavigate();

  const queryParams = new URLSearchParams();
  if (fields) {
    Object.keys(fields).forEach((key) => fields[key] && appendQueryParamIfNotEmpty(queryParams, 'fields', key));
  }

  if (AdCode) appendQueryParamIfNotEmpty(queryParams, 'adCode', AdCode.trim());
  if (Status) appendQueryParamIfNotEmpty(queryParams, 'status', Status);
  if (referrer) appendQueryParamIfNotEmpty(queryParams, 'referrer', referrer.trim());
  if (originalReferrer) appendQueryParamIfNotEmpty(queryParams, 'originalReferrer', originalReferrer.trim());
  if (superOfficeId) appendQueryParamIfNotEmpty(queryParams, 'superOfficeId', superOfficeId.trim());
  if (digId) appendQueryParamIfNotEmpty(queryParams, 'digId', digId.trim());
  if (orderBy) appendQueryParamIfNotEmpty(queryParams, 'orderBy', orderBy.trim());
  if (sortBy) appendQueryParamIfNotEmpty(queryParams, 'sortBy', sortBy.trim());

  appendQueryParamIfNotEmpty(queryParams, 'from', formatDate(from));
  appendQueryParamIfNotEmpty(queryParams, 'to', formatDate(to));
  appendQueryParamIfNotEmpty(queryParams, 'rows', rows);
  appendQueryParamIfNotEmpty(queryParams, 'page', page);

  const queryKey = generateQueryKey(identifier, queryParams);

  return useQuery(
    [`form-submission_${queryKey}`],
    () => dataFetch.get(`${CORE_API_SUFFIX}form-submission/get-all-by-date?${queryParams}`).then((res) => res.data),
    {
      onSuccess: () => {
        navigate(`${window.location.pathname}?${queryParams.toString()}`, { replace: true });
      },
    },
  );
};

export default useGetFormSubmissions;
